<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <b-link class="brand-logo">
        <logo />

        <h2 class="brand-text text-primary ml-1">Amini Finance</h2>
      </b-link>
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title class="mb-1">
            🚀 ثبت نام در پنل آموزشی امیر امینی
          </b-card-title>

          <validation-observer ref="registerForm" #default="{ invalid }">
            <b-form class="auth-register-form mt-2" @submit.prevent="register">
              <b-form-group
                label="موبایل یا ایمیل"
                label-for="register-username"
              >
                <validation-provider
                  #default="{ errors }"
                  name="username"
                  vid="username"
                  rules="required|mobileEmail"
                >
                  <b-form-input
                    autocomplete="on"
                    id="register-username"
                    v-model.trim="userName"
                    name="register-username"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <div class="d-flex justify-content-between">
                <b-form-group
                  label="نام"
                  class="mr-1"
                  label-for="register-firstname"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="firstname"
                    vid="firstname"
                    rules="required|totalPerisan"
                  >
                    <b-form-input
                      autocomplete="on"
                      id="register-firstname"
                      v-model="firstname"
                      name="register-firstname"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group
                  class="ml-1"
                  label="نام خانوادگی"
                  label-for="register-lastname"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="lastname"
                    vid="lastname"
                    rules="required|totalPerisan"
                  >
                    <b-form-input
                      autocomplete="on"
                      id="register-lastname"
                      v-model="lastname"
                      name="register-lastname"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </div>
              <div class="d-flex justify-content-between">
                <b-form-group
                  class="mr-1"
                  label-for="register-password"
                  label="رمز عبور"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Password"
                    vid="password"
                    rules="required|min:6|password|notArabic"
                  >
                    <b-input-group
                      class="input-group-merge"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                    >
                      <b-form-input
                        autocomplete="on"
                        id="register-password"
                        v-model.trim="password"
                        class="form-control-merge"
                        :type="
                          toggleConfrimPasswordVisibility ? 'password' : 'text'
                        "
                        :state="errors.length > 0 ? false : null"
                        name="register-password"
                        placeholder="············"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          :icon="
                            toggleConfrimPasswordVisibility
                              ? 'EyeIcon'
                              : 'EyeOffIcon'
                          "
                          class="cursor-pointer"
                          @click="
                            toggleConfrimPasswordVisibility =
                              !toggleConfrimPasswordVisibility
                          "
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group
                  class="ml-1"
                  label-for="register-confrim-password"
                  label="تایید رمز عبور"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="confrim-password"
                    vid="confrim-password"
                    :rules="`required|min:6|password|notArabic|confirmed:${password}`"
                  >
                    <b-input-group
                      class="input-group-merge"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                    >
                      <b-form-input
                        autocomplete="on"
                        id="register-confrim-password"
                        v-model.trim="confrimPassword"
                        class="form-control-merge"
                        :type="togglePasswordVisibility ? 'password' : 'text'"
                        :state="errors.length > 0 ? false : null"
                        name="register-confrim-password"
                        placeholder="············"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          :icon="
                            togglePasswordVisibility ? 'EyeIcon' : 'EyeOffIcon'
                          "
                          class="cursor-pointer"
                          @click="
                            togglePasswordVisibility = !togglePasswordVisibility
                          "
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </div>

              <!-- <b-form-group>
                <b-form-checkbox
                  id="register-privacy-policy"
                  v-model.trim="status"
                  name="checkbox-1"
                >
                  با
                  <b-link>قوانین و مقررات</b-link>
                  موافقم.
                </b-form-checkbox>
              </b-form-group> -->

              <b-button
                variant="primary"
                block
                type="submit"
                :disabled="invalid"
              >
                ثبت نام
              </b-button>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2">
            <span>ثبت نام کرده اید ؟</span>
            <b-link :to="{ name: 'auth-login' }">
              <span>ورود</span>
            </b-link>
          </p>

          <div class="divider my-2"></div>
          <div
            class="auth-footer-btn d-flex justify-content-around align-items-baseline"
          >
            <b-card-text class="text-center mt-2">
              <span class="mr-1">شماره پشتیبانی</span>
              <b-link href="tel:+989191952581">
                <span>09191952581</span>
              </b-link>
            </b-card-text>

            <b-button
              variant="gradient-danger"
              class="btn-icon"
              href="https://instagram.com/amini.finance"
            >
              <feather-icon icon="InstagramIcon" />
            </b-button>
          </div>
        </b-col>
      </b-col>
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div
          class="w-100 d-lg-flex align-items-center justify-content-center px-5"
        >
          <b-img fluid :src="imgUrl" alt="Register V2" />
        </div>
      </b-col>
    </b-row>
    <loader :loading="loading" />
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Logo from "@core/layouts/components/Logo.vue";
import {
  BRow,
  BCol,
  BLink,
  BButton,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BImg,
  BCardTitle,
  BCardText,
} from "bootstrap-vue";
import { required, mobileEmail, notArabic } from "@validations";
import store from "@/store/index";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Loader from "@/@core/components/loader/Loader.vue";

export default {
  components: {
    Logo,
    BRow,
    BImg,
    BCol,
    BLink,
    BButton,
    BForm,
    BCardText,
    BCardTitle,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    Loader,
  },
  data() {
    return {
      status: "",
      userName: "",
      lastname: "",
      firstname: "",
      password: "",
      confrimPassword: "",
      loading: false,
      togglePasswordVisibility: true,
      toggleConfrimPasswordVisibility: true,
      sideImg: require("@/assets/images/login.png"),
      required,
      mobileEmail,
      notArabic,
    };
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        this.sideImg = require("@/assets/images/login.png");
        return this.sideImg;
      }
      return this.sideImg;
    },
  },
  watch: {
    userName(val) {
      this.userName = this.p2e(val).toLowerCase();
    },
    password(val) {
      this.password = this.p2e(val);
    },
    confrimPassword(val) {
      this.confrimPassword = this.p2e(val);
    },
  },
  methods: {
    register() {
      this.$refs.registerForm.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          try {
            const { data } = await this.$http.post("/auth/register", {
              username: this.userName,
              password: this.password,
              password_confirmation: this.confrimPassword,
              first_name: this.firstname,
              last_name: this.lastname,
            });
            await this.$store.dispatch("auth/setUserName", this.userName);
            this.loading = false;
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: `کد تایید ثبت نام با موفقیت برای شما ارسال شد`,
                  icon: "InfoIcon",
                  variant: "success",
                },
              },
              { position: "bottom-right" }
            );
            this.$router.push({ name: "auth-verify" });
          } catch (err) {
            this.loading = false;
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
